import React, { useState, useEffect } from "react";

import { FileManagerProvider } from '../contexts/FileManagerContext';

import DocumentViewerModal from "./DocumentViewerModal";
import DocumentUploadModal from "./DocumentUploadModal";

import FileManager from "./FileManager";

const ListDoxExt = ({ lstDoxExt, refreshDoxExt, autoOpenDoc }) => {

    const [isUploadVisible, setIsUploadVisible] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [isViewerVisible, setIsViewerVisible] = useState(false);
    const [pendingUpdatedUuid, setPendingUpdatedUuid] = useState(null);
    const [tabOpen, setTabOpen] = useState("drawing");
    const [viewerReloadKey, setViewerReloadKey] = useState(0);


    useEffect(() => {
        if (!autoOpenDoc) return;

        if (Array.isArray(lstDoxExt) && lstDoxExt.length > 0) {
            const doc = lstDoxExt.find(d => d.UUID_ === autoOpenDoc.uuidDoc);
            if (doc) {
                setSelectedDocument(doc);
                setIsViewerVisible(true);
                return;
            }
        }

        if (autoOpenDoc.infoOrigine) {
            setSelectedDocument(autoOpenDoc.infoOrigine);
            setIsViewerVisible(true);
        }
    }, [autoOpenDoc, lstDoxExt]);

    useEffect(() => {
        if (!pendingUpdatedUuid || !Array.isArray(lstDoxExt)) return;

        const updated = lstDoxExt.find(d => d.UUID_ === pendingUpdatedUuid);
        if (updated) {
            setSelectedDocument(updated);
            setPendingUpdatedUuid(null);
            setIsViewerVisible(true);

            setViewerReloadKey(k => k + 1);
        }
    }, [lstDoxExt, pendingUpdatedUuid]);



    const closeViewer = () => {
        setIsViewerVisible(false);
        setSelectedDocument(null);
    };

    const handleAddDocument = (tabSelected) => {
        setTabOpen(tabSelected);
        setIsUploadVisible(true);
    };

    const handleCloseUpload = () => {
        setIsUploadVisible(false);
    };

    const handleUploadSuccess = (updatedUuid) => {
        setIsUploadVisible(false);

        if (updatedUuid) {
            setPendingUpdatedUuid(updatedUuid);
        }

        if (typeof refreshDoxExt === 'function') {
            refreshDoxExt();
        } else {
            console.error("refreshDoxExt is not a function");
        }
    };

    console.log("selected doc", selectedDocument);
    return (
        <FileManagerProvider>
            <div className="bg-white p-4 rounded-lg">
                <div className="flex lg:flex-row flex-col justify-between items-start lg:items-center mx-auto my-4 lg:my-8 px-6 pb-4 border-gray-300 border-b container">
                    <div>
                        <h4 className="font-bold text-gray-800 text-2xl leading-tight">
                            Documents Externes
                        </h4>
                        <ul className="flex md:flex-row flex-col items-start md:items-center mt-3 text-gray-600 text-sm">
                            <li className="flex items-center mt-3 md:mt-0 mr-3">
                                <span className="mr-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon-tabler icon-tabler-paperclip icon"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path stroke="none" d="M0 0h24v24H0z" />
                                        <path d="M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9 l6.5 -6.5" />
                                    </svg>
                                </span>
                                <span>
                                    {lstDoxExt.filter(doc => doc.Type_Document !== "folder").length}{" "}
                                    {lstDoxExt.filter(doc => doc.Type_Document !== "folder").length === 1 ? "Document" : "Documents"}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className="space-x-4 mt-6 lg:mt-0">
                        <label class="font-bold text-orange-600"> Ajouter</label>
                        <button
                            onClick={() => handleAddDocument("fileUpload")}
                            className="bg-orange-600 hover:bg-orange-500 px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-orange-700 focus:ring-offset-2 text-white text-sm transition duration-300 ease-in-out"
                        >
                            des Documents <i class="ml-2 fa-solid fa-file-import"></i>
                        </button>
                        <button
                            onClick={() => handleAddDocument("note")}
                            className="bg-orange-600 hover:bg-orange-500 px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-orange-700 focus:ring-offset-2 text-white text-sm transition duration-300 ease-in-out"
                        >
                            une Note <i class="ml-2 fa-solid fa-comment"></i>
                        </button>
                        <button
                            onClick={() => handleAddDocument("drawing")}
                            className="bg-orange-600 hover:bg-orange-500 px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-orange-700 focus:ring-offset-2 text-white text-sm transition duration-300 ease-in-out"
                        >
                            un Dessin <i class="ml-2 fa-solid fa-pen-ruler"></i>
                        </button>
                    </div>
                </div>

                <div className="lg:mx-auto mb-4 lg:mb-8 px-6 container">
                    <div className="border-2 border-gray-300 hover:border-orange-400 rounded w-full transition duration-300 ease-in-out">
                        <FileManager lstDoxExt={lstDoxExt} setIsViewerVisible={setIsViewerVisible} setSelectedDocument={setSelectedDocument} refreshDoxExt={refreshDoxExt} />
                    </div>
                </div>

                <DocumentViewerModal
                    key={viewerReloadKey}          
                    reloadKey={viewerReloadKey}
                    isVisible={isViewerVisible}
                    onClose={closeViewer}
                    selectedDocument={selectedDocument}
                    lstDoxExt={lstDoxExt}
                />
                <DocumentUploadModal
                    isVisible={isUploadVisible}
                    onClose={handleCloseUpload}
                    onUploadSuccess={handleUploadSuccess}
                    tabOpen={tabOpen}
                    lstDoxExt={lstDoxExt}
                />

            </div>
        </FileManagerProvider>
    );
};

export default ListDoxExt;
